import {
  ADD_CHART_POINT,
  ADD_FILE,
  ADD_ISSUE,
  OPEN_FILE,
  RESET_STORE,
  SAVE_DATA_STORE,
  SET_CURRENT_TAB,
  SET_HARDWARE_VARIANT,
  SET_MAX_TEMP,
  SET_MAX_THREADS,
  SET_SOLSTICE_VERSION,
  SET_STATUS,
  SET_STORAGE,
  SET_ZIP_NAME,
} from './actions'

import {
  IAddChartPointAction,
  IAddFileAction,
  IAddIssueAction,
  IOpenFileAction,
  IResetStoreAction,
  ISaveDataStoreAction,
  ISetCurrentTabAction,
  ISetHardwareVariantAction,
  ISetMaxTempAction,
  ISetMaxThreadsAction,
  ISetSolsticeVersionAction,
  ISetStatusAction,
  ISetStorageAction,
  ISetZipNameAction,
} from './actions'

import { IFile, IState } from './types'

export const initialState: IState = {
  buildNumber: 'Unknown',
  chartPoints: [],
  currentTab: 7,
  datastore: {
    columns: [],
    values: [],
  },
  files: [],
  hardwareVariant: 'Unknown',
  issues: [],
  maxThreads: {
    fileId: NaN,
    lineNumber: NaN,
    max: 0,
  },
  solsticeVersion: 'Unknown',
  status: 'IDLE',
  storage: {
    available: NaN,
    percent: '',
    total: NaN,
  },
  temperature: {
    fileId: NaN,
    lineNumber: NaN,
    max: 0,
  },
  zipName: '',
}

export type ActionTypes =
  | IAddFileAction
  | IAddIssueAction
  | IOpenFileAction
  | IResetStoreAction
  | ISetZipNameAction
  | ISetHardwareVariantAction
  | ISetMaxTempAction
  | ISetMaxThreadsAction
  | ISetSolsticeVersionAction
  | ISetStorageAction
  | IAddChartPointAction
  | ISetStatusAction
  | ISaveDataStoreAction
  | ISetCurrentTabAction

const reducer = (state: IState = initialState, action: ActionTypes): IState => {
  switch (action.type) {
    case ADD_FILE: {
      return {
        ...state,
        files: state.files.concat(action.data.file)
      }
    }
    case ADD_ISSUE: {
      return {
        ...state,
        issues: state.issues.concat(action.data.issues)
      }
    }
    case OPEN_FILE: {
      const { id } = action.data
      const files = state.files.map((file: IFile) => {
        const result = file.id === id
          ? Object.assign({}, file, { open: true })
          : Object.assign({}, file, { open: false })
        return result
      })
      return {
        ...state,
        files,
      }
    }
    case RESET_STORE: {
      return initialState
    }
    case SET_ZIP_NAME: {
      return {
        ...state,
        zipName: action.data.zipName,
      }
    }
    case SET_HARDWARE_VARIANT: {
      return {
        ...state,
        hardwareVariant: action.data.hardwareVariant,
      }
    }
    case SET_SOLSTICE_VERSION: {
      return {
        ...state,
        buildNumber: action.data.buildNumber,
        solsticeVersion: action.data.version,
      }
    }
    case SET_STORAGE: {
      return {
        ...state,
        storage: action.data.storage,
      }
    }
    case SET_MAX_TEMP: {
      return {
        ...state,
        temperature: action.data.temperature,
      }
    }
    case SET_MAX_THREADS: {
      return {
        ...state,
        maxThreads: action.data.maxThreads,
      }
    }
    case ADD_CHART_POINT: {
      return {
        ...state,
        chartPoints: state.chartPoints.concat(action.data.chartPoint)
      }
    }
    case SET_STATUS: {
      return {
        ...state,
        currentTab: (action.data.status === "BROWSING" ? 0 : state.currentTab),
        status: action.data.status,
      }
    }
    case SAVE_DATA_STORE: {
      return {
        ...state,
        datastore: action.data.datastore,
      }
    }
    case SET_CURRENT_TAB: {
      return {
        ...state,
        currentTab: action.data.currentTab,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers.ts